export default __webpack_public_path__ + "static/media/avatar.816d9d09.svg";